import { render } from "./TaskDetails.vue?vue&type=template&id=64e011dc"
import script from "./TaskDetails.vue?vue&type=script&lang=ts"
export * from "./TaskDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script